import { Controller } from "stimulus";
import "select2"
import {
  addHtmlElementClass, isValidEmail,
  parseShipmentAddress, removeHtmlChildren,
  removeHtmlElementClass, setHtmlElementValue, setHtmlElementContent,
  veryHighDebouncedFunction, getHtmlElement
} from "../utils/utils";


export default class extends Controller {
    static targets = [ "ownerEmail", "companyId", "userHomePickUpAddress", "userShipmentAddress", "middleman", "middlemanHomePickUpAddress", "middlemanShipmentAddress", "middlemanDeliveryMethod" ];

    initialize() {
        this.displayUserAddresses();
        this.displayMiddlemenAddresses();
    }




    // Funzione che gestisce il rendering degli indirizzi utente sull'interfaccia grafica
    displayUserAddresses() {
        if (this.ownerEmailTarget.value) {
            removeHtmlElementClass(document, "user-addresses-container", "d-none");
        }
        else {
          addHtmlElementClass(document, "user-addresses-container", "d-none");
          setHtmlElementValue(document, 'user_home_pick_up_address_id', null);
          setHtmlElementValue(document, 'user_shipment_address_id', null);
          this.handleChangeUserHomePickUpAddressId();
          this.handleChangeUserShipmentAddressId();
        }
    }

    // Funzione che gestisce il rendering degli indirizzi dell'aggregatore sull'interfaccia grafica
    displayMiddlemenAddresses() {
        if (this.middlemanTarget.value) {
            removeHtmlElementClass(document, "middleman-addresses-container", "d-none");
        }
        else {
          addHtmlElementClass(document, "middleman-addresses-container", "d-none");
          setHtmlElementValue(document, 'middleman_home_pick_up_address_id', null);
          setHtmlElementValue(document, 'middleman_shipment_address_id', null);
          this.handleChangeMiddlemanHomePickUpAddressId();
          this.handleChangeMiddlemanShipmentAddressId();
        }
    }




    // Funzione che gestisce il cambio dell'email dell'utente proprietario della submission list
    handleChangeUserEmail() {
        setHtmlElementValue(document, "user_id", null);
        setHtmlElementValue(document, "user_home_pick_up_address_id", '');
        setHtmlElementValue(document, "user_shipment_address_id", '');
        veryHighDebouncedFunction(this.checkUserByEmail, [this.ownerEmailTarget.value, this.fillAddressesSelect, this.userHomePickUpAddressTarget, this.userShipmentAddressTarget]);
    }

    // Funzione che chiede al server, mediante richiesta http, l'id e gli indirizzi del nuovo utente proprietario della
    // submission list
    checkUserByEmail(email, fillAddressesSelect, userHomePickUpAddressTarget, userShipmentAddressTarget) {
        if (!email) {
            removeHtmlElementClass(document, "email-outcome", "color-red");
            removeHtmlElementClass(document, "email-outcome", "color-green");
            removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
            setHtmlElementContent(document, "email-outcome", "");

            fillAddressesSelect(userHomePickUpAddressTarget, []);
            fillAddressesSelect(userShipmentAddressTarget, []);
            addHtmlElementClass(document, "user-addresses-container", "d-none");
            setHtmlElementValue(document, 'user_home_pick_up_address_id', null);
            setHtmlElementValue(document, 'user_shipment_address_id', null);
            addHtmlElementClass(document, 'new_user_home_pick_up_address_container', 'd-none');
            addHtmlElementClass(document, 'copy_user_home_pick_up_address_button', 'd-none');
            addHtmlElementClass(document, 'new_user_shipment_address_container', 'd-none');
            addHtmlElementClass(document, 'copy_user_shipment_address_button', 'd-none');
        } else if (!isValidEmail(email)) {
            addHtmlElementClass(document, "email-outcome", "color-red");
            removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
            removeHtmlElementClass(document, "email-outcome", "color-green");
            setHtmlElementContent(document, "email-outcome", "Invalid User Email!")

            fillAddressesSelect(userHomePickUpAddressTarget, []);
            fillAddressesSelect(userShipmentAddressTarget, []);
            addHtmlElementClass(document, "user-addresses-container", "d-none");
            setHtmlElementValue(document, 'user_home_pick_up_address_id', null);
            setHtmlElementValue(document, 'user_shipment_address_id', null);
            addHtmlElementClass(document, 'new_user_home_pick_up_address_container', 'd-none');
            addHtmlElementClass(document, 'copy_user_home_pick_up_address_button', 'd-none');
            addHtmlElementClass(document, 'new_user_shipment_address_container', 'd-none');
            addHtmlElementClass(document, 'copy_user_shipment_address_button', 'd-none');
        } else {
            const url = `/backoffice/users/all/check_user_by_email.json?email=${email}&get_user_addresses=true`;

            fetch(url, {
                method: "GET"
            })
              .then((response) => {
                  if (!response.ok)
                      throw Error("An error occour during saving data on the database");
                  else
                      return response.json();
              })
              .then((userData) => {
                  if (userData) {
                      fillAddressesSelect(userHomePickUpAddressTarget, [ ...userData.addresses, { id: 'new_user_home_pick_up_address' }]);
                      fillAddressesSelect(userShipmentAddressTarget, [ ...userData.addresses, { id: 'new_user_shipment_address' }]);
                      removeHtmlElementClass(document, "user-addresses-container", "d-none");

                      if (userData.user_id) {
                          setHtmlElementValue(document, "user_id", userData.user_id);
                          addHtmlElementClass(document, "email-outcome", "color-green");
                          removeHtmlElementClass(document, "email-outcome", "color-red");
                          removeHtmlElementClass(document, "email-outcome", "color-dark-orange");
                          setHtmlElementContent(document, "email-outcome", "Valid User Email!");
                      } else {
                          addHtmlElementClass(document, "email-outcome", "color-dark-orange");
                          removeHtmlElementClass(document, "email-outcome", "color-red");
                          removeHtmlElementClass(document, "email-outcome", "color-green");
                          setHtmlElementContent(document, "email-outcome", "SHADOW USER!")
                      }
                  }
              })
              .catch((error) => {
                  console.error("ERROR:", error);
              });
        }
    }




    // Funzione che gestisce il cambio dell'aggregatore abbinato alla submission list
    handleChangeMiddleman() {
        setHtmlElementValue(document, "middleman_home_pick_up_address_id", null);
        setHtmlElementValue(document, "middleman_shipment_address_id", null);
        setHtmlElementValue(document, "middleman_delivery_method_id", null);
        this.displayMiddlemenAddresses();


        const url = `/backoffice/companies/${this.companyIdTarget.value}/middlemen/get_all_addresses/${this.middlemanTarget.value}`;

        fetch(url, {
            method: "GET"
        })
          .then((response) => {
              if (!response.ok)
                  throw Error("An error occour during saving data on the database");
              else
                  return response.json();
          })
          .then((addresses) => {
              this.fillAddressesSelect(this.middlemanHomePickUpAddressTarget, [ ...addresses, { id: 'new_middleman_home_pick_up_address' }]);
              this.fillAddressesSelect(this.middlemanShipmentAddressTarget, [ ...addresses, { id: 'new_middleman_shipment_address' }]);
              this.fillAddressesSelect(this.middlemanDeliveryMethodTarget, []);
          })
          .catch((error) => {
              console.error("ERROR:", error);
          });
    }




    // Funzione che gestisce il cambio dell'indirizzo di ritiro a domicilio del pacco presso il domicilio del cliente
    handleChangeUserHomePickUpAddressId() {
        const address_id = this.userHomePickUpAddressTarget.value;
        if (address_id.toString().indexOf('new') > -1) {
          removeHtmlElementClass(document, 'new_user_home_pick_up_address_container', 'd-none');
          removeHtmlElementClass(document, 'copy_user_home_pick_up_address_button', 'd-none');
        }
        else {
          addHtmlElementClass(document, 'new_user_home_pick_up_address_container', 'd-none');
          addHtmlElementClass(document, 'copy_user_home_pick_up_address_button', 'd-none');
        }
    }




    // Funzione che gestisce il cambio dell'indirizzo di consegna di ritorno del pacco presso il domicilio del cliente
    handleChangeUserShipmentAddressId() {
      const address_id = this.userShipmentAddressTarget.value;
      if (address_id.toString().indexOf('new') > -1) {
        removeHtmlElementClass(document, 'new_user_shipment_address_container', 'd-none');
        removeHtmlElementClass(document, 'copy_user_shipment_address_button', 'd-none');
      } else {
        addHtmlElementClass(document, 'new_user_shipment_address_container', 'd-none');
        addHtmlElementClass(document, 'copy_user_shipment_address_button', 'd-none');
      }
    }




    // Funzione che copia i valori dall'indirizzo di consegna di ritorno all'indirizzo di ritiro a domicilio dell'utente
    handleCopyUserShipmentAddress(event) {
      event.preventDefault();

      const homePickUpContainer = getHtmlElement(document, 'new_user_home_pick_up_address_container');
      const shipmentContainer = getHtmlElement(document, 'new_user_shipment_address_container');

      const homePickUpInputs = homePickUpContainer.querySelectorAll('.address-input-form');

      homePickUpInputs.forEach((homePickUpInput) => {
        const homePickUpId = homePickUpInput.id;
        const shipmentId = homePickUpId.replace('home_pick_up_address', 'shipment_address');
        const shipmentInput = shipmentContainer.querySelector(`#${shipmentId}`);

        if (shipmentInput) {
          // Per checkbox, simula un click se il valore è diverso
          if (homePickUpInput.type === 'checkbox') {
            if (homePickUpInput.checked !== shipmentInput.checked) {
              homePickUpInput.click();
            }
          } else {
            // Per input/select normali, usa il native setter per forzare React a intercettare il cambio
            const nativeSetter = Object.getOwnPropertyDescriptor(
              homePickUpInput.tagName === 'SELECT' ? window.HTMLSelectElement.prototype : window.HTMLInputElement.prototype,
              'value'
            ).set;
            nativeSetter.call(homePickUpInput, shipmentInput.value);

            // Trigger eventi per i componenti React
            const inputEvent = new Event('input', { bubbles: true });
            homePickUpInput.dispatchEvent(inputEvent);

            const changeEvent = new Event('change', { bubbles: true });
            homePickUpInput.dispatchEvent(changeEvent);
          }
        }
      });
    }




    // Funzione che copia i valori dall'indirizzo di ritiro a domicilio all'indirizzo di consegna di ritorno dell'utente
    handleCopyUserHomePickUpAddress(event) {
      event.preventDefault();

      const shipmentContainer = getHtmlElement(document, 'new_user_shipment_address_container');
      const homePickUpContainer = getHtmlElement(document, 'new_user_home_pick_up_address_container');

      const shipmentInputs = shipmentContainer.querySelectorAll('.address-input-form');

      shipmentInputs.forEach((shipmentInput) => {
        const shipmentId = shipmentInput.id;
        const homePickUpId = shipmentId.replace('shipment_address', 'home_pick_up_address');
        const homePickUpInput = homePickUpContainer.querySelector(`#${homePickUpId}`);

        if (homePickUpInput) {
          // Per checkbox, simula un click se il valore è diverso
          if (shipmentInput.type === 'checkbox') {
            if (shipmentInput.checked !== homePickUpInput.checked) {
              shipmentInput.click();
            }
          } else {
            // Per input/select normali, usa il native setter per forzare React a intercettare il cambio
            const nativeSetter = Object.getOwnPropertyDescriptor(
              shipmentInput.tagName === 'SELECT' ? window.HTMLSelectElement.prototype : window.HTMLInputElement.prototype,
              'value'
            ).set;
            nativeSetter.call(shipmentInput, homePickUpInput.value);

            // Trigger eventi per i componenti React
            const inputEvent = new Event('input', { bubbles: true });
            shipmentInput.dispatchEvent(inputEvent);

            const changeEvent = new Event('change', { bubbles: true });
            shipmentInput.dispatchEvent(changeEvent);
          }
        }
      });
    }




    // Funzione che copia i valori dall'indirizzo di consegna di ritorno all'indirizzo di ritiro a domicilio dell'aggregatore
    handleCopyMiddlemanShipmentAddress(event) {
      event.preventDefault();

      const homePickUpContainer = getHtmlElement(document, 'new_middleman_home_pick_up_address_container');
      const shipmentContainer = getHtmlElement(document, 'new_middleman_shipment_address_container');

      const homePickUpInputs = homePickUpContainer.querySelectorAll('.address-input-form');

      homePickUpInputs.forEach((homePickUpInput) => {
        const homePickUpId = homePickUpInput.id;
        const shipmentId = homePickUpId.replace('home_pick_up_address', 'shipment_address');
        const shipmentInput = shipmentContainer.querySelector(`#${shipmentId}`);

        if (shipmentInput) {
          // Per checkbox, simula un click se il valore è diverso
          if (homePickUpInput.type === 'checkbox') {
            if (homePickUpInput.checked !== shipmentInput.checked) {
              homePickUpInput.click();
            }
          } else {
            // Per input/select normali, usa il native setter per forzare React a intercettare il cambio
            const nativeSetter = Object.getOwnPropertyDescriptor(
              homePickUpInput.tagName === 'SELECT' ? window.HTMLSelectElement.prototype : window.HTMLInputElement.prototype,
              'value'
            ).set;
            nativeSetter.call(homePickUpInput, shipmentInput.value);

            // Trigger eventi per i componenti React
            const inputEvent = new Event('input', { bubbles: true });
            homePickUpInput.dispatchEvent(inputEvent);

            const changeEvent = new Event('change', { bubbles: true });
            homePickUpInput.dispatchEvent(changeEvent);
          }
        }
      });
    }




    // Funzione che copia i valori dall'indirizzo di ritiro a domicilio all'indirizzo di consegna di ritorno dell'aggregatore
    handleCopyMiddlemanHomePickUpAddress(event) {
      event.preventDefault();

      const shipmentContainer = getHtmlElement(document, 'new_middleman_shipment_address_container');
      const homePickUpContainer = getHtmlElement(document, 'new_middleman_home_pick_up_address_container');

      const shipmentInputs = shipmentContainer.querySelectorAll('.address-input-form');

      shipmentInputs.forEach((shipmentInput) => {
        const shipmentId = shipmentInput.id;
        const homePickUpId = shipmentId.replace('shipment_address', 'home_pick_up_address');
        const homePickUpInput = homePickUpContainer.querySelector(`#${homePickUpId}`);

        if (homePickUpInput) {
          // Per checkbox, simula un click se il valore è diverso
          if (shipmentInput.type === 'checkbox') {
            if (shipmentInput.checked !== homePickUpInput.checked) {
              shipmentInput.click();
            }
          } else {
            // Per input/select normali, usa il native setter per forzare React a intercettare il cambio
            const nativeSetter = Object.getOwnPropertyDescriptor(
              shipmentInput.tagName === 'SELECT' ? window.HTMLSelectElement.prototype : window.HTMLInputElement.prototype,
              'value'
            ).set;
            nativeSetter.call(shipmentInput, homePickUpInput.value);

            // Trigger eventi per i componenti React
            const inputEvent = new Event('input', { bubbles: true });
            shipmentInput.dispatchEvent(inputEvent);

            const changeEvent = new Event('change', { bubbles: true });
            shipmentInput.dispatchEvent(changeEvent);
          }
        }
      });
    }




    // Funzione che gestisce il cambio dell'indirizzo di ritiro a domicilio del pacco presso il domicilio dell'aggregatore
    handleChangeMiddlemanHomePickUpAddressId() {
      const address_id = this.middlemanHomePickUpAddressTarget.value;
      if (address_id.toString().indexOf('new') > -1) {
        removeHtmlElementClass(document, 'new_middleman_home_pick_up_address_container', 'd-none');
        removeHtmlElementClass(document, 'copy_middleman_home_pick_up_address_button', 'd-none');
      }
      else {
        addHtmlElementClass(document, 'new_middleman_home_pick_up_address_container', 'd-none');
        addHtmlElementClass(document, 'copy_middleman_home_pick_up_address_button', 'd-none');
      }
    }




    // Funzione che gestisce il cambio dell'indirizzo di consegna di ritorno del pacco presso il domicilio dell'aggregatore
    handleChangeMiddlemanShipmentAddressId() {
      const address_id = this.middlemanShipmentAddressTarget.value;
      if (address_id.toString().indexOf('new') > -1) {
        removeHtmlElementClass(document, 'new_middleman_shipment_address_container', 'd-none');
        removeHtmlElementClass(document, 'copy_middleman_shipment_address_button', 'd-none');
      }
      else {
        addHtmlElementClass(document, 'new_middleman_shipment_address_container', 'd-none');
        addHtmlElementClass(document, 'copy_middleman_shipment_address_button', 'd-none');
      }
    }




    // Funzione che renderizza sull'interfaccia grafica gli indirizzi dell'utente / aggregatore della submission list
    fillAddressesSelect(target, addresses) {
        removeHtmlChildren(target);

        target.insertAdjacentHTML(
          "beforeend",
          "<option value=''>Select address</option>"
        );

        for (const address of addresses) {
          console.log('address: ', address)
          console.log('address.id.toString().indexOf(\'new\') > -1: ', address.id.toString().indexOf('new') > -1)
            target.insertAdjacentHTML(
              "beforeend",
              `<option value='${address.id}'>` + (address.id.toString().indexOf('new') > -1 ? 'New Address' : parseShipmentAddress(address)) + "</option>"
            );
        }
    }
}